import * as React from 'react';
import { useDocument } from './useDocument';
/**
 * Returns a function, which gets the `defaultView` based on the `ownerDocument` of the element.
 */
export var useWindow = function (ref) {
    var getDocument = useDocument(ref);
    var getWindow = React.useCallback(function () {
        var document = getDocument();
        return document
            ? document.defaultView || window
            : window;
    }, [getDocument]);
    return getWindow;
};
